module.exports = __webpack_public_path__ + "static/img/permit.cc3ebf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/permit.png
// module id = YR4M
// module chunks = 31